export default "__VITE_ASSET__fcc9c226__"